<template>
    <section class="content">
        <div class="row">
            <reset-password :show="showResetPassword" @close="showResetPassword = false" @updateSenha="(password)=>{updateSenha(password)}"></reset-password>
            <div class="col-md-12">
                <alert></alert> <!-- rederizando componente alert -->
                <div class="box box-solid">
                    <div class="box-header with-border">
                        <h3 class="box-title"><b>Usuários do Sistema</b></h3>
                        <router-link tag="button" class="btn btn-default pull-right" to="/usuarios/novo"><i class="fa fa-plus"></i> Novo</router-link>
                    </div>

                    <div class="box-body">
                        <div class="row">
                            <div class="col-md-12">
                                <input style="width: 100%" class="form-control" placeholder="Busca: Entre com o nome do usuário" name="filtro_pesquisa" type="text" v-model="filtro" @keyup.enter="getUsers">
                            </div>
                        </div>
                        <div class="row" style="margin-top:15px">
                            <div class="col-sm-12 table-responsive">
                                <table aria-describedby="example1_info" role="grid" id="example1" class="table table-bordered table-striped">
                                    <thead>
                                        <tr role="row">
                                            <th style="width: 10%">ID</th>
                                            <th style="width: 35%">Nome</th>
                                            <th style="width: 43%">Email</th>
                                            <th style="width: 12%">Ação</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        <tr class="even" role="row" v-for="item in apiData.data">
                                            <td>{{ item.id }}</td>
                                            <td>{{ item.name }}</td>
                                            <td>{{ item.email }}</td>
                                            <td>
                                                <router-link tag="a"  :to="'/usuarios/atualizacao/'+ item.id" title="Editar"><i class="fa fa-fw fa-edit"></i></router-link>
                                                <a title='Excluir' href="javascript:void(0)" @click="deleteUser(item.id, item.name)"><i class="fa fa-fw fa-times"></i></a>
                                                <a title='Resetar Senha' href="javascript:void(0)" @click="selecionaUsuario(item)"><i class="fa fa-fw fa-key"></i></a>
                                            </td>
                                        </tr>
                                    </tbody>
                                </table>

                                <div class="row">
                                    <div class='col-sm-5'>
                                        Mostrando {{ this.apiData.from }} até {{ this.apiData.to }} de {{ this.apiData.total }} registros encontrados.
                                    </div>
                                    <div class='col-sm-7' style="text-align:right">
                                        <laravue-pagination :data="apiData" v-on:pagination-change-page="getUsers">
                                            <span slot="prev-nav">&lt; Anterior</span>
                                            <span slot="next-nav">Próximo &gt;</span>
                                        </laravue-pagination>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div> <!-- /.box-body -->
                </div> <!-- /.box -->
            </div> <!-- /.col-md-12 -->
        </div> <!-- /.row -->
    </section>
</template>
<script>
    import axios from 'axios' // Cliente para requisição http
    import Alert from '../Alert' // Importando componente alert 
    import ResetPassword from './ResetPassword'

    export default {
        data: () => ({
            usuarioSelecionado: null,
            showResetPassword: false,
            filtro: '',
            apiData: {},
        }),
        mounted () {
            this.getUsers()
        },

        methods: {
            selecionaUsuario(user) {
                this.usuarioSelecionado = user;
                this.showResetPassword = true;
            },
            updateSenha(password) {
                axios.post(`${this.$store.state.serverURI}/api/usuario/updatePassword/` + this.usuarioSelecionado.id, {password}, this.$store.getters.getHeaderAuth).then(response => {

                  this.$store.commit('SHOW_ALERT_SUCCESS');
                  this.$router.push('/usuarios');

              }).catch((error) => {
                  this.$store.commit('SHOW_ALERT_ERROR');
                  console.log(error)
              });
          },
          getUsers(page) {

            if (typeof page === 'undefined') {
                page = 1;
            }
            this.$store.commit('TOGGLE_LOADING');
            axios.get(`${this.$store.state.serverURI}/api/usuario/getAllPaginate` + ((this.filtro) ? '/' + this.filtro : '') + '/?page=' + page, this.$store.getters.getHeaderAuth)
            .then(response => {
                this.apiData = response.data;
                this.$store.commit('TOGGLE_LOADING');
            }).catch((error) => { this.$store.commit('throwException', error); });

        },
        deleteUser(id, nome) {
            var self = this;
            this.$dialog.confirm(`Tem certeza que deseja excluir o usuário ${nome}?`, {okText: 'Sim',
                cancelText: 'Não'})
            .then(function () {
                axios.delete(`${self.$store.state.serverURI}/api/usuario/delete/` + id, self.$store.getters.getHeaderAuth).then(response => {
                    self.$store.commit('TOGGLE_LOADING');
                    self.$store.commit('SHOW_ALERT_SUCCESS');
                    self.getUsers();

                }).catch((error) => { 
                    self.$store.commit('SHOW_ALERT_ERROR');
                    console.log(error) 
                });
            })
        }
    },
    watch: {
        page: function (val) {
            this.getUsers();
        }
    },

    components: {
        Alert,
        ResetPassword
    }

}
</script>
<style>
    .box.box-solid>.box-header .btn.btn-default {
        background-color: #f4f4f4;
        color: #444;
        border-color: #ddd;
    }

    .box.box-solid>.box-header .btn.btn-default:hover {
     color: #333;
     background-color: #d4d4d4;
     border-color: #8c8c8c;
 }


</style>


// WEBPACK FOOTER //
// List.vue?14f9b5b2